import useSWR from "swr";
import { fetcher } from "../../../common/hooks";
import { DeviceSettings } from "../models";

export const useDeviceSettings = ({
    companyId,
}: {
    companyId?: string;
    refreshInterval?: number;
}) => {
    const getAPI = () => {
        if (!companyId) {
            return null;
        }
        return `/api/device-management/v1/companies/${companyId}/settings`;
    };
    const { data, error, isLoading, mutate } = useSWR(getAPI(), fetcher);

    return {
        deviceSettings: data as DeviceSettings,
        isLoadingDeviceSettings: isLoading,
        isError: error,
        mutateDeviceSettings: mutate,
    };
};
